
import { defineComponent } from "vue";
import { isBoss } from "@/utils/auth";
import LookupDataService from "@/services/LookupDataService";

export default defineComponent({
  name: "CompanySettingsView",
  props: {
    baseUrl: { type: String, required: true }
  },
  data() {
    return {
      minutes: 2 as number,
      isSaving: false
    };
  },
  methods: {
    loadFromLookupData() {
      const cached = LookupDataService.getData();
      if (cached && cached.defaultCheckCallIntervalMinutes) {
        this.minutes = cached.defaultCheckCallIntervalMinutes;
        return;
      }

      // Defensive fallback if the cache is empty for some reason (e.g.
      // cleared manually) - matches the fallback-fetch precedent used
      // elsewhere in this app rather than leaving the field blank.
      fetch(`${this.baseUrl}AppData/GetAllLookupData`, {
        headers: { Authorization: `Bearer ${localStorage.token}` }
      })
        .then(r => r.json())
        .then(data => {
          LookupDataService.saveData(data);
          if (data && data.defaultCheckCallIntervalMinutes) {
            this.minutes = data.defaultCheckCallIntervalMinutes;
          }
        })
        .catch(error => console.error("Error fetching lookup data:", error));
    },

    save() {
      const value = Number(this.minutes);
      if (!Number.isInteger(value) || value <= 0) {
        alert("Please enter a positive whole number of minutes");
        return;
      }

      this.isSaving = true;
      fetch(`${this.baseUrl}CompanyParameters/UpdateDefaultCheckCallInterval`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ minutes: value })
      })
        .then(async r => {
          if (!r.ok) {
            const body = await r.json().catch(() => null);
            throw new Error(body?.title || `HTTP ${r.status}`);
          }
          return r.json();
        })
        .then((result: any) => {
          // No manual lookupData refetch here - the backend's
          // NotifyLookupDataChangedAsync() call triggers the existing
          // SignalR listener (SignalRService.ts) to refresh it automatically.
          this.minutes = result.defaultCheckCallIntervalMinutes ?? this.minutes;
          alert("Default check-call interval updated!");
        })
        .catch(error => {
          console.error("Error updating default check-call interval:", error);
          alert(`Error updating default check-call interval: ${error.message}`);
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  },
  mounted() {
    if (!isBoss()) {
      this.$router.replace("/schedule");
      return;
    }

    this.loadFromLookupData();
  }
});
